import React, { useContext } from "react";
import queryString from "query-string";
import { useHistory } from "react-router";
import { RESOURCE_NAME } from "common/authorization";
import { buildLink } from "common/routing";
import { outsideOfBoundary } from "common-client/utils/geospatial";
import { AuthContext } from "../../Authorization/AuthContext";
import { Icon } from "../../Common/Icons/LucideIcons";
import { CreatePropertyParamsInput } from "../../Property/CreateProperty";
import { Viewport } from "../utils/viewportHook";
import { MapTool, MapToolControl } from "./__styles__/MapTools";
import { MapToolLabel } from "./MapToolLabel";

export const CreatePropertyTool = ({ viewport }: { viewport: Viewport }) => {
  const history = useHistory();
  const { authorized, account } = useContext(AuthContext);

  const canCreateProperty = authorized({
    resource: RESOURCE_NAME.PROPERTY,
    permission: "create",
  });

  const buttonLabel = "Add new property";

  const createProperty = ({ viewport }: { viewport: Viewport }) => {
    const pathname = buildLink("createProperty");

    const queryParameters = {
      latitude: viewport.latitude,
      longitude: viewport.longitude,
      zoom: viewport.zoom,
    } satisfies CreatePropertyParamsInput;

    history.push({
      pathname,
      search: `?${queryString.stringify(queryParameters)}`,
    });
  };

  if (
    !canCreateProperty ||
    outsideOfBoundary({ point: viewport, boundary: account!.bounds })
  ) {
    return null;
  }

  return (
    <MapTool>
      <MapToolLabel label={buttonLabel} />
      <MapToolControl
        aria-label={buttonLabel}
        styleVariant="outlineLight"
        onClick={() => createProperty({ viewport })}
      >
        <Icon iconName="map-pin" color="contentPrimary" size={16} />
      </MapToolControl>
    </MapTool>
  );
};
